var searchTyping,
  selector = {
    searchButton: "[data-search-button]",
    searchBar: "[data-search-wrapper]",
    serachResult: "[data-search-body]",
    searchInput: "[data-search-input]",
    searchForm: "[data-search-form]",
    serachRecent: "[data-recent-search-result]",
    searchClose: "[data-search-close]",
    searchRecentSuggestion: "[data-recent-suggestion]",
    clearRecentSearch: "[data-clear-recent]",
    searchTabItems: "[data-search-tab]",
    clearInputContent: "[data-clear-input]",
  };
let searchForm = document.querySelectorAll(selector.searchForm),
  searchRecentSuggestion = document.querySelectorAll(
    selector.searchRecentSuggestion
  ),
  formURl = searchurl;
Array.from(searchForm).forEach(function (e) {
  (formURl = e.getAttribute("action")),
    e.addEventListener("submit", function (e) {
      let r = e.target,
        t = r.elements,
        c = t.q.value;
      c.replace(/\s/g, "").length > 0 && setRecentSearch(c);
    });
});
let searchSelectors = document.querySelectorAll(selector.searchButton);
var searchBar = document.querySelector(selector.searchBar);
function setRecentSearchOnBody() {
  document.querySelectorAll(selector.serachRecent) &&
    Array.from(document.querySelectorAll(selector.serachRecent)).forEach(
      function (e) {
        getRecentSearch() && e
          ? (console.log("recent", getRecentSearch()),
            (e.innerHTML = getRecentSearch()),
            clearRecentSearch())
          : (document.querySelector(
              "[data-header-seach-body] [data-recent-suggestion]"
            ).innerHTML = "");
      }
    );
}
searchSelectors &&
  Array.from(searchSelectors).forEach(function (e) {
    e.addEventListener("click", (r) => {
      r.preventDefault(),
        document.querySelector("body").classList.add("no-scroll"),
        setTimeout(() => {
          searchBar.style.display = "flex";
        }, 200),
        setTimeout(() => {
          searchBar.classList.add("show");
        }, 300),
        setTimeout(() => {
          "" == previousFocusElement && (previousFocusElement = e),
            focusElementsRotation(searchBar);
        }, 1e3),
        document.querySelectorAll(selector.searchInput) &&
          Array.from(document.querySelectorAll(selector.searchInput)).forEach(
            function (e) {
              setTimeout(() => {
                e.focus();
              }, 1e3);
            }
          ),
        setRecentSearchOnBody(),
        searchResult((document.querySelector(selector.searchInput).value = ""));
    });
  });
let searchCloses = document.querySelectorAll(selector.searchClose);
searchCloses &&
  Array.from(searchCloses).forEach(function (e) {
    e.addEventListener("click", (e) => {
      e.preventDefault(),
        searchBar.classList.contains("show") &&
          (document.querySelector("body").classList.remove("no-scroll"),
          setTimeout(() => {
            searchBar.classList.remove("show");
          }, 500),
          setTimeout(() => {
            searchBar.style.display = "none";
          }, 700),
          stopFocusRotation(),
          previousFocusElement.focus(),
          (previousFocusElement = ""));
    });
  }),
  document.querySelectorAll(selector.searchInput) &&
    Array.from(document.querySelectorAll(selector.searchInput)).forEach(
      function (e) {
        e.classList.contains("header-group-search") &&
          e.addEventListener("click", (r) => {
            r.preventDefault(),
              setRecentSearchOnBody(),
              e
                .closest("[data-header-searchbox]")
                .querySelector("[data-header-seach-body]")
                .classList.add("open");
          }),
          e.addEventListener("keyup", (r) => {
            r.preventDefault(),
              clearTimeout(searchTyping),
              searchRecentSuggestion &&
                Array.from(searchRecentSuggestion).forEach(function (e) {
                  e.classList.add("hidden");
                }),
              (searchTyping = setTimeout(function () {
                let r = e.value;
                r.replace(/\s/g, "").length > 0 && setRecentSearch(r),
                  console.log("searchTerm", r),
                  searchResult(r);
              }, 500));
          });
      }
    ),
  document.querySelectorAll(selector.clearInputContent) &&
    Array.from(document.querySelectorAll(selector.clearInputContent)).forEach(
      function (e) {
        e.addEventListener("click", (r) => {
          e.closest("form").querySelector(selector.searchInput).value = "";
          let t = e.closest("form").querySelector(selector.searchInput).value;
          e.classList.contains("header-searchbar-clear") &&
            e
              .closest("[data-header-searchbox]")
              .querySelector("[data-header-seach-body]")
              .classList.remove("open"),
            searchResult(t);
        });
      }
    );
var searchResult = function (e) {
    let r = document.querySelectorAll(selector.serachResult),
      t = document.querySelector(selector.serachRecent);
    "" == e &&
      searchRecentSuggestion &&
      Array.from(searchRecentSuggestion).forEach(function (e) {
        console.log(e), e.classList.remove("hidden");
      }),
      e.replace(/\s/g, "").length > 0
        ? (r &&
            Array.from(r).forEach(function (e) {
              e.innerHTML = preLoaderIcon;
            }),
          setTimeout(() => {
            fetch(
              formURl +
                "/suggest?section_id=predictive-search&q=" +
                e +
                "&resources[type]=product,article,query,collection,page&resources[limit]=8&resources[limit_scope]=each"
            )
              .then((e) => e.text())
              .then((e) => {
                let c = new DOMParser().parseFromString(e, "text/html");
                r &&
                  Array.from(r).forEach(function (e) {
                    e.innerHTML = c.querySelector(
                      "#shopify-section-predictive-search"
                    ).innerHTML;
                    sideDrawerInt(),
                      productVariantOption(e),
                      quantitySelectors(),
                      productCardHoverInit();
                  }),
                  getRecentSearch() &&
                    r &&
                    (t && (t.innerHTML = getRecentSearch()),
                    clearRecentSearch(),
                    searchTabs(),
                    animationStatus && AOS && AOS.refreshHard());
              });
          }, 10))
        : (Array.from(r).forEach(function (e) {
            e.innerHTML = "";
          }),
          getRecentSearch() &&
            t &&
            ((t.innerHTML = getRecentSearch()),
            searchTabs(),
            clearRecentSearch(),
            animationStatus && AOS && AOS.refreshHard()));
  },
  setRecentSearch = function (e) {
    var r = JSON.parse(localStorage.getItem("recent-search-items")) || [];
    r.length > 0
      ? 0 > r.indexOf(e) &&
        (r.length >= 20 && r.shift(),
        r.push(e),
        localStorage.setItem("recent-search-items", JSON.stringify(r)))
      : (r.push(e),
        localStorage.setItem("recent-search-items", JSON.stringify(r)));
  },
  clearRecentSearch = function () {
    document.querySelectorAll(selector.clearRecentSearch) &&
      Array.from(document.querySelectorAll(selector.clearRecentSearch)).forEach(
        function (e) {
          e.addEventListener("click", function () {
            localStorage.removeItem("recent-search-items"),
              e.closest("[data-header-seach-body]")
                ? (e
                    .closest("[data-header-seach-body]")
                    .querySelector("[data-recent-suggestion]").innerHTML = "")
                : (document.querySelector(selector.serachRecent).innerHTML =
                    "");
          });
        }
      );
  },
  getRecentSearch = function () {
    let e = "";
    if (localStorage.getItem("recent-search-items")) {
      let r = JSON.parse(localStorage.getItem("recent-search-items"));
      r.length > 0 &&
        ((e =
          '<h6 class="predictive-search-heading">' +
          recentHeading +
          ' <button type="button" class="clear-search" data-clear-recent>' +
          clearbtnRecent +
          '</button></h6> <ul class="list-inline predictive-search-popular-list">'),
        r.reverse(),
        Array.from(r).forEach(function (r, t) {
          "" != r &&
            (e +=
              '<li class="predictive-search-popular-item"><a class="predictive-search-popular-link" href="' +
              searchurl +
              "?q=" +
              r +
              '">' +
              r +
              "</a></li>");
        }),
        (e += "</ul>"));
    }
    return e;
  };
function searchTabs() {
  var e = function () {
      for (
        var e = document.querySelectorAll(selector.searchTabItems), r = 0;
        r < e.length;
        r++
      ) {
        e[r].classList.remove("active");
        var t = e[r].getAttribute("data-results");
        e[r]
          .closest("[data-search-body]")
          .querySelector(`[data-content="${t}"]`)
          .classList.remove("active");
      }
    },
    r = function (r) {
      e(), r.target.closest(selector.searchTabItems).classList.add("active");
      var t = r.currentTarget.getAttribute("data-results");
      console.log(r),
        r.target
          .closest("[data-search-body]")
          .querySelector(`[data-content="${t}"]`)
          .classList.add("active");
    };
  !(function () {
    for (
      var e = document.querySelectorAll(selector.searchTabItems), t = 0;
      t < e.length;
      t++
    )
      e[t].addEventListener("click", r, !1),
        e[t].addEventListener(
          "keydown",
          function (e) {
            (13 == e.keyCode || 32 == e.keyCode) && r(e);
          },
          !1
        );
  })();
}
let isMouseHover = !1,
  elementsToFind = document.querySelectorAll(
    "[data-header-seach-body], [data-header-search-form]"
  );
Array.from(elementsToFind).forEach(function (e) {
  e.addEventListener("mouseleave", function (e) {
    (isMouseHover = !1), console.log(isMouseHover);
  }),
    e.addEventListener("mouseover", function (e) {
      (isMouseHover = !0), console.log(isMouseHover);
    });
}),
  document.querySelector("body").addEventListener("click", function () {
    !isMouseHover &&
      document.querySelector("[data-header-seach-body]") &&
      document
        .querySelector("[data-header-seach-body]")
        .classList.remove("open");
  });
